<template>
  <t-form labelWidth="100px">
    <div class="formItemDiv">边框样式：</div>
    <t-row>
      <t-col :span="6" v-for="(item, index) in borderTypes" :key="item.value">
        <div style="height: 80px;overflow: hidden;cursor: pointer" @click="onStyleBorder(item)">
          <component :is="item.value" style="height: 80px;" />
        </div>
      </t-col>
    </t-row>
    <t-form-item label="边框颜色1">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.borderColor1"
        enableAlpha />
    </t-form-item>
    <t-form-item label="边框颜色2">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.borderColor2"
        enableAlpha />
    </t-form-item>
    <t-form-item label="背景颜色">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.backgroundColor"
        enableAlpha />
    </t-form-item>
    <t-form-item label="层级">
      <t-input-number size="small" v-model="attribute.zIndex" />
    </t-form-item>
    <template v-if="currentCpt.cptType === 'ngcombination-border'">
      <t-form-item label="单元格模式">
        <t-switch v-model="attribute.switchGrid" size="small" @change="onChange" :label="['开', '关']" />
      </t-form-item>
      
    <e-collapse title="弹窗配置" :expand="false">
      <t-form-item label="弹窗位置">
        <t-radio-group v-model="attribute.popAlign" size="small">
          <t-radio-button value="screen">屏幕位置</t-radio-button>
          <!-- <t-radio-button value="left">靠左</t-radio-button>
          <t-radio-button value="right">靠右</t-radio-button>
          <t-radio-button value="top">靠上</t-radio-button>
          <t-radio-button value="bottom">靠下</t-radio-button> -->
          <t-radio-button value="mouse">跟随鼠标</t-radio-button>
          <t-radio-button value="cpt">跟随点击控件</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="弹窗位于屏幕" v-show="attribute.popAlign == 'screen'">
        <t-radio-group v-model="attribute.popAlignScreen" size="small">
          <t-radio-button value="center">居中</t-radio-button>
          <t-radio-button value="lefttop">左上</t-radio-button>
          <t-radio-button value="centertop">中上</t-radio-button>
          <t-radio-button value="righttop">右上</t-radio-button>
          <t-radio-button value="leftcenter">左中</t-radio-button>
          <t-radio-button value="leftbottom">左下</t-radio-button>
          <t-radio-button value="bottomcenter">下中</t-radio-button>
          <t-radio-button value="bottomright">下右</t-radio-button>
          <t-radio-button value="rightcenter">右中</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="弹窗位于鼠标" v-show="attribute.popAlign == 'mouse'">
        <t-radio-group v-model="attribute.popAlignMouse" size="small">
          <t-radio-button value="lefttop">左上</t-radio-button>
          <t-radio-button value="centertop">中上</t-radio-button>
          <t-radio-button value="righttop">右上</t-radio-button>
          <t-radio-button value="leftcenter">左中</t-radio-button>
          <t-radio-button value="leftbottom">左下</t-radio-button>
          <t-radio-button value="bottomcenter">下中</t-radio-button>
          <t-radio-button value="bottomright">下右</t-radio-button>
          <t-radio-button value="rightcenter">右中</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="上偏移距离" v-show="attribute.popAlign == 'mouse' || attribute.popAlign == 'cpt' || attribute.popAlign == 'screen'">
        <t-input-number size="small" v-model="attribute.mouseTop" />
      </t-form-item>
      <t-form-item label="左偏移距离" v-show="attribute.popAlign == 'mouse' || attribute.popAlign == 'cpt' || attribute.popAlign == 'screen'">
        <t-input-number size="small" v-model="attribute.mouseLeft" />
      </t-form-item>
      <t-form-item label="弹窗关闭按钮">
        <t-switch v-model="attribute.isCloseBtn" size="small" :label="['开', '关']" />
      </t-form-item>
      <t-form-item label="是否需要蒙版">
        <t-switch v-model="attribute.isOverlay" size="small" :label="['开', '关']" />
      </t-form-item>
      <t-form-item label="点蒙板区域关闭" v-show="attribute.isOverlay">
        <t-switch v-model="attribute.isCloseOther" size="small" :label="['开', '关']" />
      </t-form-item>
      <t-form-item label="蒙板颜色" v-show="attribute.isOverlay">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.overlayColor"
          size="small"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="原始边框样式" :expand="false">
      <t-form-item label="使用原始边框样式">
        <t-radio-group v-model="attribute.isSelfBorder" size="small">
          <t-radio :value="true">开启</t-radio>
          <t-radio :value="false">关闭</t-radio>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="边框宽度">
        <t-input-number size="small" v-model="attribute.selfBorderSize" :min="0" :max="9999" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="边框颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.selfBorderColor" />
      </t-form-item>
      <t-form-item label="边框圆角">
        <t-input-number size="small" v-model="attribute.selfBorderRadius" :min="0" :max="9999" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.selfBgColor" />
      </t-form-item>

    </e-collapse>

    

      <e-collapse title="勾选样式配置" :expand="false">
        <t-form-item label="未选中背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.bgColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="未选中边框颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.brColor"
          size="small"
        />
      </t-form-item>

      <t-form-item label="选中背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeBgColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中边框颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeBrColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="选中颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.activeBg"
          size="small"
        />
      </t-form-item>
      <t-form-item label="垂直位置">
        <t-input-number size="small" v-model="attribute.top" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="水平位置">
        <t-input-number size="small" v-model="attribute.left" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="边框圆角">
        <t-input-number size="small" v-model="attribute.borderRadius" :min="0"  :decimal-places="0" />
      </t-form-item>
      </e-collapse>

    </template>
    
    <div v-if="attribute.borderType === 'dv-border-box-8'">
      <t-form-item label="动画时长">
        <t-input-number size="small" v-model="attribute.dur" :min="1" :max="60" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="动画方向">
        <t-select size="small" v-model="attribute.reverse" placeholder="请选择">
          <t-option label="逆时针" :value="true" />
          <t-option label="顺时针" :value="false" />
        </t-select>
      </t-form-item>
    </div>
    <div v-if="attribute.borderType === 'dv-border-box-11'">
      <t-form-item label="标题">
        <t-input size="small" v-model="attribute.borderTitle" />
      </t-form-item>
      <t-form-item label="标题宽度">
        <t-input-number size="small" v-model="attribute.titleWidth" :min="10" :max="1200" :decimal-places="0" />
      </t-form-item>
    </div>

  </t-form>
</template>

<script>
export default {
  name: "cpt-dataV-border-option",
  props: { attribute: Object, currentCpt: Object, refMap: Object },
  data() {
    return {
      borderTypes: [
        { value: 'dv-border-box-1', label: '样式1' },
        { value: 'dv-border-box-2', label: '样式2' },
        { value: 'dv-border-box-3', label: '样式3' },
        { value: 'dv-border-box-4', label: '样式4' },
        { value: 'dv-border-box-5', label: '样式5' },
        { value: 'dv-border-box-6', label: '样式6' },
        { value: 'dv-border-box-7', label: '样式7' },
        { value: 'dv-border-box-8', label: '样式8' },
        { value: 'dv-border-box-9', label: '样式9' },
        { value: 'dv-border-box-10', label: '样式10' },
        /*{ value: 'dv-border-box-11', label: '样式11' },大量使用时会导致GPU资源占用过高*/
        { value: 'dv-border-box-12', label: '样式12' },
        { value: 'dv-border-box-13', label: '样式13' }
      ]
    }
  },
  mounted() {
  },
  methods: {
    onStyleBorder(item) {
      this.attribute.borderType = item.value
    },

    onChange(val) {
      this.currentCpt.group.forEach(gid => {
        if (this.refMap[gid].current && this.refMap[gid].current.cptType == 'ngcombination') {
          this.refMap[gid].onChange(val)
          // this.refMap[gid].current.cptOption.attribute.isPop = val
        }
      })
    },
  }
}
</script>

<style scoped>
.formItemDiv {
  width: 100%;
  line-height: 30px;
  text-indent: 1em;
  font-size: 13px;
  color: var(--td-text-color-primary)
}
</style>
